import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_backoffice/user/')({
  beforeLoad: () => {
    throw redirect({
      to: '/user/admin'
    })
  }
})
